import { DynamicUxClientState } from "@ms-ofb/floodgate-shared-typings";
import * as Configuration from "../Configuration/Configuration";
import * as DynamicUxClient from "../UI/DynamicUx/DynamicUxClient";

// helper method for determining whether session is Floodgate2
export function isFloodgate2(isUxSchemaPresent: boolean): boolean {
    const isDynamicUXEnabled = Configuration.get().getFloodgateInitOptions()?.dynamicUxConfig?.enabled ?? false;

    const dynamicUXClientState = DynamicUxClient?.get()?.getStatus();

    if (isDynamicUXEnabled)
    {
        // corner case where dynUXClient didn't succeed, but dynamic UX is enabled
        if (dynamicUXClientState !== DynamicUxClientState.Success){
            return false;
        }
        else {
            return isUxSchemaPresent;
        }
    }
    else {
        return false;
    }		
}